import { Col, Row } from "reactstrap";
import { AddIcon, ClearAllIcon, ExportIcon, FilterIcon } from "../../utils/icon.utils";
import Search from "../../ui/Search";
import Button from "../../ui/Button";
import { useHasPermission } from "../../utils/route.utils";

export default function MoneyReceiptToolBar({
  handleAdd,
  handleFilterToggle,
  filteredValues,
  onFilterClear,
  onSearch,
  searchText = "",
  isSearched,
  handleSearchClear,
  onExport,
  isExporting = false
}) {
  const { hasPermission } = useHasPermission();

  return (
    <Row className="align-items-center g-3 flex-column-reverse mb-3 flex-md-row">
      <Col md={4}>
        <Search
          name={"caid"}
          onSubmit={onSearch}
          placeholder={"Type anything..."}
          defaultValue={searchText}
          isSearched={isSearched}
          handleClear={handleSearchClear}
        />
      </Col>
      <Col md={8}>
        <div className="d-flex align-items-center justify-content-end gap-1">
          {hasPermission(["money-receipt-list:export"]) && (
            <Button
              color="info"
              icon={ExportIcon}
              name={isExporting ? "Exporting..." : "Export Excel"}
              onClick={onExport}
              disabled={isExporting}
            />
          )}
          <Button color="primary" icon={AddIcon} name="Add Money Receipt" onClick={handleAdd} />
          {!!handleFilterToggle && (
            <Button color="secondary" icon={FilterIcon} onClick={handleFilterToggle} />
          )}
          {!!filteredValues && (
            <Button color="danger" icon={ClearAllIcon} onClick={onFilterClear} />
          )}
        </div>
      </Col>
    </Row>
  );
}
